import { OpusAgentPlaybook } from "@src/types.generated";
import { OpusAgentSendAttachment } from "./attachments/sendGate";

let queued: OpusAgentPlaybook[] | null = null;
let queuedAttachments: OpusAgentSendAttachment[] | null = null;

// The "Create X with AI" dialog queues these beside its first message; the
// Ask Opus panel takes them and sends them with that message.
export const queueFirstMessagePlaybooks = (
  playbooks: OpusAgentPlaybook[],
): void => {
  queued = playbooks;
};

export const takeFirstMessagePlaybooks = (): OpusAgentPlaybook[] | null => {
  const playbooks = queued;
  queued = null;
  return playbooks;
};

// The dialog's ready attachments, in pill order, ride the same way.
export const queueFirstMessageAttachments = (
  attachments: OpusAgentSendAttachment[],
): void => {
  queuedAttachments = attachments.length ? attachments : null;
};

export const takeFirstMessageAttachments = ():
  | OpusAgentSendAttachment[]
  | null => {
  const attachments = queuedAttachments;
  queuedAttachments = null;
  return attachments;
};
